/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Finish_Confirm_TitleInputs */



/**
* | output |
* | --- |
* | "Finish tournament?" |
*
* @param {Finish_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const finish_confirm_title = /** @type {((inputs?: Finish_Confirm_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Finish_Confirm_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Terminer le tournoi ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Finalizar el torneo?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Finalizar o torneio?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Concludere il torneo?")
	return /** @type {LocalizedString} */ ("Finish tournament?")
});